/**
 * Will act as the default wrapper for all module states within the application
 * that call it within their own Layouts
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import AuthoringTopNav from './AuthoringTopNav.js.jsx';

const AuthoringLayout = (props) => {
  return (
    <div className="-author-layout">
      <AuthoringTopNav />
      <div className="-content">
        {props.children}
      </div>
    </div>
  )
}

export default AuthoringLayout;



// WEBPACK FOOTER //
// modules/admin/components/AuthoringLayout.js.jsx